(function() {
    'use strict';


    AgreementsContinuityOfCareController.$inject = [];

    function AgreementsContinuityOfCareController() {
        var vm = this; //jshint ignore:line
        vm.save = save;
        vm.isSaving = false;
        init();

        function init() {
            if (vm.agreement) {
                if (vm.agreement.dateSigned === null || vm.agreement.dateSigned === undefined) {
                    vm.agreement.dateSigned = new Date(); // default dateSigned is today
                }
            }
        }

        function save() {
            vm.isSaving = true;
            agreementsEmit();
            vm.isSaving = false;
        }

        function agreementsEmit() {
            vm.onChange({agreement: vm.agreement ? vm.agreement : null});
        }

    }

    angular.module('ipmApp').component('agreementsContinuityOfCare', {
        bindings: {
            agreement: '<',
            onChange: '&'
        },
        templateUrl: 'app/agreements-workflow/agreements-continuity-of-care/agreements-continuity-of-care.html',
        controller: AgreementsContinuityOfCareController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', function ($translate) {
                return $translate.refresh();
            }]
        }
    })
})();
